import { PDFDocument, rgb } from "pdf-lib";
import downloadjs from "downloadjs";
import fontkit from "@pdf-lib/fontkit";
//import downloadjs from "downloadjs";
//import Email from "./smtp";

export async function downloadPDF(firstName, lastName) {
  const url = "https://pdf-lib.js.org/assets/dod_character.pdf";
  //"https://bears.vipfanportal.com/babybears/files/BabyContract.pdf";
  const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());

  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  // font
  // Register the `fontkit` instance
  pdfDoc.registerFontkit(fontkit);

  // Embed our custom font in the document
  const fonturl =
    //"https://bears.vipfanportal.com/cribclub/files/All-ProSans-Thin.ttf";
    "https://pdf-lib.js.org/assets/ubuntu/Ubuntu-R.ttf";
  const fontBytes = await fetch(fonturl).then((res) => res.arrayBuffer());
  const customFont = await pdfDoc.embedFont(fontBytes);

  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const { width, height } = firstPage.getSize();
  firstPage.drawText(firstName + " " + lastName, {
    x: (2 * width) / 3 - 50,
    y: (4 * height) / 5 - 15,
    size: 14,
    font: customFont,
    color: rgb(0.4, 0.4, 0.4),
  });
  // firstPage.drawText(lastName, {
  //   x: (2 * width) / 3 + 50,
  //   y: (4 * height) / 5 - 15,
  //   size: 14,
  //   font: customFont,
  //   color: rgb(0.4, 0.4, 0.4),
  // });
  // metadata
  pdfDoc.setTitle("BabyContract");
  pdfDoc.setAuthor("ChicagoBears");
  //viewer prefs
  const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences();
  viewerPrefs.setHideToolbar(true);
  viewerPrefs.setHideToolbar(true);
  viewerPrefs.setHideMenubar(true);

  const pdfDataUri = await pdfDoc.saveAsBase64({ dataUri: true });
  document.getElementById("pdf").src = pdfDataUri;

  // open pdf in new window
  // var bytes = new Uint8Array(pdfBytes);
  // var blob = new Blob([bytes], { type: "application/pdf" });
  // const docUrl = URL.createObjectURL(blob);
  // window.open(docUrl);
  //downloadjs(pdfBytes, "BabyContract.pdf", "application/pdf");
}

export async function downloadPDFButton(firstName, lastName) {
  const url = "https://bears.vipfanportal.com/babybears/files/BabyContract.pdf"; //"https://pdf-lib.js.org/assets/dod_character.pdf";
  const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());

  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  // font
  // Register the `fontkit` instance
  pdfDoc.registerFontkit(fontkit);

  // Embed our custom font in the document
  const fonturl =
    "https://bears.vipfanportal.com/babybears/files/GochiHand-Regular.ttf";
  //"https://pdf-lib.js.org/assets/ubuntu/Ubuntu-R.ttf";
  const fontBytes = await fetch(fonturl).then((res) => res.arrayBuffer());
  const customFont = await pdfDoc.embedFont(fontBytes);

  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const { width, height } = firstPage.getSize();
  firstPage.drawText(firstName + " " + lastName, {
    x: (2 * width) / 3 - 50,
    y: (4 * height) / 5 - 15,
    size: 15,
    font: customFont,
    color: rgb(0.4, 0.4, 0.4),
  });
  // firstPage.drawText(lastName, {
  //   x: (2 * width) / 3 + 50,
  //   y: (4 * height) / 5 - 15,
  //   size: 14,
  //   font: customFont,
  //   color: rgb(0.4, 0.4, 0.4),
  // });

  // metadata
  pdfDoc.setTitle("BabyContract");
  pdfDoc.setAuthor("ChicagoBears");
  //viewer prefs
  //const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences();
  //viewerPrefs.setHideToolbar(true);
  //viewerPrefs.setHideToolbar(true);
  //viewerPrefs.setHideMenubar(true);

  // open pdf in new window
  const pdfBytes = await pdfDoc.save();
  // var bytes = new Uint8Array(pdfBytes);
  // var blob = new Blob([bytes], { type: "application/pdf" });
  // const docUrl = URL.createObjectURL(blob);
  // window.open(docUrl);
  downloadjs(pdfBytes, "BabyContract.pdf", "application/pdf");
}
